const MODULE_NAME = "oncall/";

export const CITIES_PAGE_LOAD = `@@${MODULE_NAME}CITIES_PAGE_LOAD`;
export const CITIES_LOADED = `@@${MODULE_NAME}CITIES_LOADED`;

export const CITY_PAGE_LOAD = `@@${MODULE_NAME}CITY_PAGE_LOAD`;
export const CITY_PAGE_LOADED = `@@${MODULE_NAME}CITY_PAGE_LOADED`;
export const CITY_ADD_REQUEST = `@@${MODULE_NAME}CITY_ADD_REQUEST`;
export const CITY_UPDATE_REQUEST = `@@${MODULE_NAME}CITY_UPDATE_REQUEST`;
export const CITY_UPDATED = `@@${MODULE_NAME}CITY_UPDATED`;
export const CITY_ADD_ERROR = `@@${MODULE_NAME}CITY_ADD_ERROR`;
export const CITY_UPDATE_ERROR = `@@${MODULE_NAME}CITY_UPDATE_ERROR`;

// Creators for cities list
export const citiesPageLoad = () => ({
  type: CITIES_PAGE_LOAD,
  payload: {},
});

export const citiesLoaded = cities => ({
  type: CITIES_LOADED,
  payload: {
    cities,
  },
});

export const cityPageLoad = cityId => ({
  type: CITY_PAGE_LOAD,
  payload: {
    cityId,
  },
});

export const cityPageLoaded = city => ({
  type: CITY_PAGE_LOADED,
  payload: {
    city,
  },
});

export const cityAddRequest = formData => ({
  type: CITY_ADD_REQUEST,
  payload: {
    formData,
  },
});

export const cityUpdateRequest = (cityId, formData) => ({
  type: CITY_UPDATE_REQUEST,
  payload: {
    cityId,
    formData,
  },
});

export const cityUpdated = () => ({
  type: CITY_UPDATED,
  payload: {},
});

export const cityAddError = message => ({
  type: CITY_ADD_ERROR,
  payload: {
    message,
  },
});

export const cityUpdateError = message => ({
  type: CITY_UPDATE_ERROR,
  payload: {
    message,
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/cities.js